import React,{useState,useEffect} from 'react'
import './RelatedProducts.css'
// import data_product from '../Assets/data'
import Item from '../Item/Item'
const RelatedProducts = () => {



// const [f]=props;



  
  const k=`popularinplants`;
   const[popularproducts,setPopularProducts]=useState([]);
    useEffect(()=>{
      fetch(`https://sarathi-0cyh.onrender.com/${k}`)
        .then((response) => {
          if (!response.ok) throw new Error(response.statusText);
          return response.json();
        })
        .then((data) => setPopularProducts(data))
        .catch((err) => {
          console.error('Failed to fetch related products:', err);
          setPopularProducts([]);
        });
    },[k])
  return (
    <div className='relatedproducts'>
      <h1>More products</h1>
      <hr/>
      <div className="relatedproducts-item">
        {
            popularproducts.map((item,i)=>{
                return <Item key={i} id={item.id} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price}/>
            })
        }
      </div>
    </div>
  )
}

export default RelatedProducts
// import React,{useContext} from 'react'
// import './RelatedProducts.css'

// import Item from '../Item/Item'


// import { ShopContext } from '../../Context/ShopContext'



// const RelatedProducts = ({ category }) => {
//   const { all_product } = useContext(ShopContext);

//   return (
//     <div className="relatedproducts">
//       <h1>Related Products</h1>
//       <hr />
//       <div className="relatedproducts-item">
//         {all_product
//           .filter((item) => item.category === category)
//           .map((item, i) => (
//             <Item
//               key={i}
//               id={item.id}
//               name={item.name}
//               image={item.image}
//               new_price={item.new_price}
//               old_price={item.old_price}
//             />
//           ))}
//       </div>
//     </div>
//   );
// };

// export default RelatedProducts;
